module.exports = __webpack_public_path__ + "assets/da82cd1658eede131e93da471905b7ae.png";